import { plural } from '@cian/utils';
import { isNil } from 'ramda';

export const formatFloors = (floorCount: number | undefined | null, hasMansard?: boolean | null) => {
  if (!floorCount && !hasMansard) {
    return;
  }

  let result = !isNil(floorCount) ? `${floorCount} ` + plural(floorCount, ['этаж', 'этажа', 'этажей']) : '';

  if (hasMansard) {
    result += result.length ? ' и мансарда' : 'мансарда';
  }

  return result;
};
